import React from 'react'
import { Card } from 'primereact/card'
import { useNavigate } from 'react-router-dom'
import { mockClients, mockContracts, mockProjects, mockSubscriptions } from '../../../mocks'

const Overview: React.FC = () => {
  const navigate = useNavigate()

  const activeContracts = mockContracts.filter((c) => c.status === 'active').length
  const activeProjects = mockProjects.filter((p) => p.status === 'active').length
  const mrr = mockSubscriptions
    .filter((s) => s.status === 'active')
    .reduce((sum, s) => sum + s.monthlyPrice, 0)

  const stats = [
    {
      label: 'Clientes',
      value: mockClients.length,
      icon: 'pi pi-users',
      color: '#60a5fa',
      path: '/dashboard/clientes',
    },
    {
      label: 'Aplicativos Ativos',
      value: activeProjects,
      icon: 'pi pi-desktop',
      color: '#34d399',
      path: '/dashboard/aplicativos',
    },
    {
      label: 'Contratos Ativos',
      value: activeContracts,
      icon: 'pi pi-file',
      color: '#f59e0b',
      path: '/dashboard/contratos',
    },
    {
      label: 'MRR',
      value: `R$ ${mrr.toLocaleString('pt-BR')}`,
      icon: 'pi pi-credit-card',
      color: '#a78bfa',
      path: '/dashboard/assinaturas',
    },
  ]

  return (
    <div>
      <h2 style={{ marginBottom: '0.25rem' }}>Visão Geral</h2>
      <p style={{ color: 'var(--text-color-secondary)', marginBottom: '2rem', marginTop: 0 }}>
        Resumo dos projetos e clientes da BSC Tecnologia
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.5rem' }}>
        {stats.map((stat) => (
          <Card
            key={stat.label}
            className='stat-card'
            style={{ cursor: 'pointer' }}
            onClick={() => navigate(stat.path)}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '12px',
                  background: stat.color + '22',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <i className={stat.icon} style={{ fontSize: '1.4rem', color: stat.color }} />
              </div>
              <div>
                <div style={{ fontSize: '1.75rem', fontWeight: 700, lineHeight: 1 }}>{stat.value}</div>
                <div style={{ color: 'var(--text-color-secondary)', fontSize: '0.85rem', marginTop: '0.25rem' }}>
                  {stat.label}
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default Overview
